import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DirtyFormGuard } from '../../dirty-form.guard';
import { DataSetupComponent } from './data-setup/data-setup.component';

import { ClientConnectionComponent } from './client-connection/client-connection.component';
// import { AddClientComponent } from './add-client/add-client.component';
import { ClientInfoComponent } from './client-info/client-info.component';
import { CreateClientComponent } from './create-client/create-client.component';
import { SelectRolesComponent } from './select-roles/select-roles.component';
import { AddClientCompanyComponent } from './add-client-company/add-client-company.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'free-trial-create-client'
  },
  {
    path: 'free-trial-create-client',
    component: CreateClientComponent,
    canDeactivate: [DirtyFormGuard]
  },
  {
    path: 'add-client-company',
    component: AddClientCompanyComponent,
    canDeactivate: [DirtyFormGuard]
  },
  {
    path: 'data-setup',
    pathMatch: 'full',
    component: DataSetupComponent
  },
  {
    path: 'client-connection',
    component: ClientConnectionComponent,
    canDeactivate: [DirtyFormGuard]
  },  
  {
    path: 'free-trial-client-info',
    component: ClientInfoComponent
  },
  {
    path: 'free-trial-create-client',
    component: CreateClientComponent,
    canDeactivate: [DirtyFormGuard]
  },
  {
    path: 'free-trial-select-roles',
    component: SelectRolesComponent
  },
  {
    path: 'edit-client/:id',
    component: CreateClientComponent,
    canDeactivate: [DirtyFormGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FreeTrialRoutingModule { }
